import { VisaoGeral } from '../../../components';

export default VisaoGeral;
